<template>
  <div
    class="repcntrls no-scroll-track scroll-right-overlay std_noevents"
    style="--clr-scrl-back: var(--clr-back); --scrl-width: 1rem"
  >
    <div
      ref="hscrl_inner"
      class="repcntrls_inner no-scroll-track"
      @wheel.stop="e => wheelScroll(e)"
      @mousedown.stop="e => hscrl_dragScrollMousedown(e)"
    >
      <div class="repcntrls_block">
        <div class="repcntrls_block_title">{{ $t('tabs.strategy') }}:</div>
        <div class="repcntrls_block_btns">
          <div
            class="repcntrls_block_btn gw_btn gw_btn_small text_tab_small"
            :class="{
              gw_btn_active: viewProps.sw_rep_strategy == 'on',
            }"
            data-tst="rep_strategy"
            @click="handleClick('strategy', 'on')"
          >
            <i class="repcntrls_icon mdi mdi-crown mr-1" />
            {{ hero.position }}
          </div>
        </div>
      </div>

      <div
        v-for="key in ['ev', 'eq', 'eqr']"
        :key="key"
        class="repcntrls_block"
      >
        <div class="repcntrls_block_title">
          {{ key === 'ev' && showEvIn === 'pot' ? 'EV/POT%' : $t(`tabs.${key}`) }}:
        </div>
        <div
          class="repcntrls_block_btns"
          :class="{
            repcntrls_block_btns_flipped: viewProps.heroLeft,
          }"
        >
          <div
            class="repcntrls_block_btn gw_btn gw_btn_small text_tab_small"
            :data-tst="`rep_${key}_opponent`"
            :class="{
              gw_btn_active: viewProps[`sw_rep_${key}`].includes('opponent'),
            }"
            @click="handleClick(key, 'opponent')"
          >
            {{ opponent.position }}
          </div>
          <div
            class="repcntrls_block_btn gw_btn gw_btn_small text_tab_small"
            :data-tst="`rep_${key}_hero`"
            :class="{
              gw_btn_active: viewProps[`sw_rep_${key}`].includes('hero'),
            }"
            @click="handleClick(key, 'hero')"
          >
            <i class="repcntrls_icon mdi mdi-crown mr-1" />
            {{ hero.position }}
          </div>
        </div>
      </div>

      <ReportsFlopSortSwitcher
        class="ml-auto"
        :actions="actions"
        :viewProps="viewProps"
        :grouping="grouping"
        :showBetsIn="showBetsIn"
        :flopGroup="flopGroup"
        :flopSortBy="viewProps.flop_sortBy"
        style="min-width: 7rem; --uns-opener-clr-back: var(--clr-black-3)"
      />
    </div>
  </div>
</template>

<script>
import format_mix from '@/mixins/format_mix'
import ReportsFlopSortSwitcher from '@/components/Switchers/ReportsFlopSortSwitcher'
import horizontalScroll_mix from '@/components/HorizolnalScroller/horizontalScroll_mix'

export default {
  name: 'RepChartControls',

  components: {
    ReportsFlopSortSwitcher,
  },
  mixins: [format_mix, horizontalScroll_mix],
  props: {
    hero: Object,
    opponent: Object,
    viewProps: Object,
    actions: { default: () => [] },
    grouping: String,
    showBetsIn: String,
    flopGroup: String,
    showEvIn: String,
  },
  data() {
    return {}
  },
  methods: {
    handleClick(key, value) {
      const vpr = this.viewProps
      value = value.toLowerCase()
      key = `sw_rep_${key}`

      const sw_rep_strategy = key === 'sw_rep_strategy' ? value : 'off'
      this.$store.dispatch('switchers_set_item', {
        key: 'sw_rep_strategy',
        item: { payload: sw_rep_strategy },
      })

      const vv = {
        sw_rep_ev: 'off',
        sw_rep_eq: 'off',
        sw_rep_eqr: 'off',
      }

      const setVal = kkey => {
        vv[kkey] =
          vpr[kkey] === 'off'
            ? value
            : vpr[kkey] === 'hero_opponent'
              ? value
              : value === vpr[kkey]
                ? value
                : 'hero_opponent'
      }

      if (key === 'sw_rep_ev') {
        setVal('sw_rep_ev')
      } else if (key === 'sw_rep_eq') {
        setVal('sw_rep_eq')
      } else if (key === 'sw_rep_eqr') {
        setVal('sw_rep_eqr')
      }

      const keys = ['sw_rep_ev', 'sw_rep_eq', 'sw_rep_eqr']
      keys.forEach(kk => {
        this.$store.dispatch('switchers_set_item', {
          key: kk,
          item: { payload: vv[kk] },
        })
      })
    },
  },
}
</script>
<style lang="scss" scoped>
.repcntrls {
  flex: 1;
  --height: 2.25rem;
  --clr-back: var(--clr-black-1-3);
  min-height: var(--height);
  max-height: var(--height);
  background: var(--clr-back);
  border-radius: 4px;
  flex-shrink: 0;
  min-width: 0;
  display: flex;
  overflow: hidden;
  position: relative;
  &_inner {
    display: flex;
    align-items: center;
    flex-shrink: 0;
    min-width: 100%;
    min-height: 0;
    grid-gap: 1rem;
    padding: 0 1rem;
    max-width: 100%;
    overflow-x: auto;
    overflow-y: hidden;
  }
  &_block {
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 0.5rem;
    &_btns {
      display: flex;
      gap: 0.25rem;
      &_flipped {
        flex-direction: row-reverse;
      }
    }
    &_btn {
      min-width: 4.5rem;
      font-weight: 500;
      --clr-back: var(--clr-black-2-3);
      --brighten-active: 0.125;
      color: var(--clr-grey-2);
      height: 1.25rem;
      &.gw_btn_active {
        --clr-back: var(--clr-black-3);
        color: var(--clr-white-0);
      }
    }
    &_title {
      font-size: 0.8rem;
      font-weight: 700;
      color: var(--clr-grey-2);
    }
  }
}
</style>
